import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import styles from './SoftCard.module.less';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ soft, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const handleSoftCard = useCallback(() => {
    const source = logInfo ? logInfo.source : 'SoftCard_err';
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          cardName: 'SoftCardLine4',
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source_p: source,
        source_pp: logInfoData.source_p,
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.soft_card}>
      <Link
        className={styles.soft_card_img}
        to={{ pathname: `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}` }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
      </Link>
      <div className={styles.soft_card_box}>
        <Link
          to={{ pathname: `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}` }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div
            className={styles.soft_card_title}
            title={(soft.softName && soft.softName.length) > 8 ? soft.softName : ''}
          >
            {soft.softName}
          </div>
          <div className={styles.soft_card_desc}>{soft.downloadCount || 0}安装</div>
        </Link>
        <div
          className={styles.soft_card_opt}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Button
            soft={soft}
            info={{
              className: styles.soft_button,
              className_busing: styles.soft_button_busing,
              className_open: styles.soft_button_open,
            }}
            logInfo={logInfo}
          />
        </div>
      </div>
    </div>
  );
});
